import React, {useState} from 'react';
import styles from './bpid-generation-modal-content.module.scss';
import {Button, Col, Row, Spinner} from "react-bootstrap";
import SecurityService from "../../../../../../services/security-service";

const BpIdGenerationModalContent = ({securityId, entityId, onClose}) => {
  const [loading, setLoading] = useState(false);
  const [bpIdPrefix, setBpIdPrefix ] = useState("");
  const securityService = new SecurityService();

  const onInputChange = e => {
    const prefix = e.target.value;
    setBpIdPrefix(`R${prefix}`);
  }

  const patchId = async () => {
    const _ = await securityService.patchOrdersId('BP_ID', securityId, entityId, bpIdPrefix);
    setLoading(false);
    onClose();
    window.location.reload();
  }

  const generate = () => {
    setLoading(true);
    try {
      patchId();
    }catch(error){}
  }
  return (
    <div className={styles['bp-id-generation']}>
      <Row>
        <Col lg={12}>
          <div className={styles['bp-id-input']}>
            <span className={styles['highlight']}>R - </span>
            <input type="text" placeholder="XXXXXXXX" maxLength={"6"} onChange={onInputChange}/>
          </div>
        </Col>
      </Row>
      <Row className={styles['button-row']}>
        <Col lg={6}>
          <div className={styles['generate-button']}>
            <Button disabled={loading} onClick={() => generate()}>
              {loading ? <Spinner size="sm" animation="border"/> : 'GENERATE'}
            </Button>
          </div>
        </Col>
        <Col lg={6}>
          <div className={styles['cancel-button']}>
            <Button variant="secondary" onClick={() => onClose()}>CANCEL</Button>
          </div>
        </Col>
      </Row>
    </div>
  )
}

export default BpIdGenerationModalContent;
